import { render, staticRenderFns } from "./BlockContent.vue?vue&type=template&id=0a1213f8&scoped=true&"
import script from "./BlockContent.vue?vue&type=script&lang=js&"
export * from "./BlockContent.vue?vue&type=script&lang=js&"
import style0 from "./BlockContent.vue?vue&type=style&index=0&id=0a1213f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1213f8",
  null
  
)

export default component.exports